const TLAOK_RULES = {
	"WARBAND_CONSTITUTION": (node) => {
		const { alerts, children } = node;
		const childrenSlugs = children.map(c => c.entrySlug);
		const mainstayCount = children.filter(r => r.type === "mainstay").length;
		const restrictedCount = children.filter(r => r.type === "restricted").length;;
		const characterNode = children.find(c => c.type === "character");
		const regimentNodes = children.filter(r => ["mainstay", "restricted"].includes(r.type));
		const { listEntry } = characterNode;
		let eligibleRegimentNodes = regimentNodes.filter(r => ![
			"war-chariots",
			"hunting-pack",
			"flame-berserkers",
			"morrowen",
			"will-o-wisps"
		].includes(r.listEntry.slug)
		)
		if (!listEntry.tagGroups?.find(g => g.slug === "special-rules")?.tags?.find(t => t.slug === "irregular")) {
			eligibleRegimentNodes = eligibleRegimentNodes.filter(n => !n.listEntry.tagGroups?.find(g => g.slug === "special-rules")?.tags?.find(t => t.slug === "irregular"));
		}
		const eligibleRegimentTypes = eligibleRegimentNodes.map(r => r.listEntry.type);

		const { type: characterType } = listEntry;
		const allMainstay = (listEntry.warband.mainstay || []).map(e => e.slug);
		const allRestricted = (listEntry.warband.restricted || []).map(e => e.slug);

		if (["fallen-divinity", "jotnar-seidr", "promethean-oracle"].includes(listEntry.slug)) {
			if (mainstayCount + restrictedCount > 2) {
				alerts.push({ message: `${listEntry.name} can only have up to two Regiments in its Warband.` });
			}
		}

		if (["maharajah", "sorcerer", "raj"].includes(listEntry.slug) && characterNode.selections.includes("bound-to-the-elements")) {
			const courts = listEntry.tagGroups.find(g => g.slug === "battlefield-role").tags.filter(t => t.slug.startsWith("court-of")).map(t => t.slug);
			let found = false;

			children.forEach(e => {
				if (e.type === "character") return;

				const eCourts = e.listEntry.tagGroups.find(g => g.slug === "battlefield-role")?.tags?.filter(t => t.slug.startsWith("court-of"))?.map(t => t.slug) || [];
				if (courts.filter(c => eCourts.includes(c)).length > 0) found = true;
			})

			if (!found) {
				alerts.push({ message: `${listEntry.name} must include at least one Regiment of the same Court to join.` });
			}
		}

		if (["winglord-predator", "theokrator", "promethean-oracle", "jorogumo-geisha", "jorogumo-mahotsu"].includes(listEntry.slug)) {
			if (mainstayCount + restrictedCount < 1) {
				alerts.push({ message: `${listEntry.name} must include at least one Regiment in its Warband.` });
			}
		}

		if (characterNode.selections.includes("war")) {
			const chosen = children.filter(c => c.entrySlug === "chosen-of-war").length;
			if (chosen > 2) {
				alerts.push({ message: `This Warband may include up to two Chosen of War Regiments.` });
			}
		} else if (characterNode.selections.includes("death")) {
			const chosen = children.filter(c => c.entrySlug === "chosen-of-death").length;
			if (chosen > 2) {
				alerts.push({ message: `This Warband may include up to two Chosen of Death Regiments.` });
			}
		} else if (characterNode.selections.includes("famine")) {
			const chosen = children.filter(c => c.entrySlug === "chosen-of-famine").length;
			if (chosen > 2) {
				alerts.push({ message: `This Warband may include up to two Chosen of Famine Regiments.` });
			}
		} else if (characterNode.selections.includes("conquest") && characterNode.entrySlug !== "scion-of-conquest") {
			const chosen = children.filter(c => c.entrySlug === "chosen-of-conquest").length;
			if (chosen > 2) {
				alerts.push({ message: `This Warband may include up to two Chosen of Conquest Regiments.` });
			}
		}

		if (["maharajah", "raj", "sorcerer"].includes(listEntry.slug) && listEntry.type === "Infantry") {
			const canHaveFifth = childrenSlugs.filter(x => ["rajakur", "dhanurveda-archers"].includes(x)).length > 0;
			if (mainstayCount + restrictedCount > 5 && canHaveFifth) {
				alerts.push({ message: "Up to five Regiments can be added to this Warband." });
			} else if (mainstayCount + restrictedCount > 4 && !canHaveFifth) {
				alerts.push({ message: "Up to four Regiments can be added to the Warband." });
			}
		} else if (["vargyr-lord"].includes(listEntry.slug)) {
			const countGoltr = children.filter(c => c.entrySlug === "goltr-beastpack").length;
			const countFenr = children.filter(c => c.entrySlug === "fenr-beastpack").length;

			if (countGoltr > 2) {
				alerts.push({ message: "This Warband may not contain more than 2 Regiments of Goltr Beatpack." });
			}
			if (countFenr > 2) {
				alerts.push({ message: "This Warband may not contain more than 2 Regiments of Fenr Beastpack." });
			}
		} else if (mainstayCount + restrictedCount > 4) {
			alerts.push({ message: "Up to four Regiments can be added to the Warband." });
		}

		if (restrictedCount > mainstayCount) {
			alerts.push({ message: "Restricted Regiment choices must not exceed the number of Mainstay." });
		}

		if (restrictedCount > 2) {
			alerts.push({ message: "Up to two Restricted Regiments can be added to the Warband." });
		}

		if (listEntry.slug === "ardent-kerawegh" && children.filter(c => c.entrySlug === "flame-berserkers").length > 2) {
			alerts.push({ message: "Up to two Regiments of Flame Berserkers can be added to this Warband." });
		}

		if (listEntry.slug === "tempered-sorcerer" && children.filter(c => c.entrySlug === "inferno-automata").length > 2) {
			alerts.push({ message: "Up to two Regiments of Inferno Automata can be added to this Warband." });
		}

		if (listEntry.slug === "tempered-steelshaper" && children.filter(c => c.entrySlug === "inferno-automata").length > 2) {
			alerts.push({ message: "Up to two Regiments of Inferno Automata can be added to this Warband." });
		}

		if (listEntry.slug === "lineage-highborne" && children.filter(c => c.entrySlug === "incarnate-sentinels").length > 2) {
			alerts.push({ message: "This Warband may not contain more than 2 Regiments of Incarnate Sentinels." });
		}

		if (listEntry.slug === "lineage-prideborne" && children.filter(c => c.entrySlug === "centaur-avatara").length > 2) {
			alerts.push({ message: "This Warband may not contain more than 2 Regiments of Centaur Avatara." });
		}

		if (listEntry.slug === "lineage-prideborne" && children.filter(c => c.entrySlug === "leonine-avatara").length > 2) {
			alerts.push({ message: "This Warband may not contain more than 2 Regiments of Leonine Avatara." });
		}

		if (listEntry.slug === "lost-ancestor" && children.filter(c => c.entrySlug === "lost").length > 2) {
			alerts.push({ message: "Up to two Regiments of Lost can be added to this Warband." });
		}

		if (listEntry.slug === "lost-ancestor" && children.filter(c => c.entrySlug === "found").length > 2) {
			alerts.push({ message: "Up to two Regiments of Found can be added to this Warband." });
		}

		if (listEntry.slug === "mounted-strategos" && children.filter(c => c.entrySlug === "kataphraktoi").length > 2) {
			alerts.push({ message: "Up to two Regiments of Kataphraktoi can be added to this Warband." });
		}

		if (listEntry.slug === "eidolon" && children.filter(c => c.entrySlug === "inquisitors").length > 3) {
			alerts.push({ message: "Up to three Regiments of Inquisitors can be added to this Warband." });
		}

		if (listEntry.slug === "imperial-officer" && children.filter(c => c.entrySlug === "steel-legion").length > 2) {
			alerts.push({ message: "Up to two Regiments of Steel Legion can be added to this Warband." });
		}

		children.filter(c => c.type === "mainstay").forEach(c => {
			const selectorPath = characterNode.linkedNodes?.["mainstay-selector"]?.[0];
			if (selectorPath === c.path) return;

			if (
				!allMainstay.includes(c.listEntry.slug) &&
				!characterNode.selections.includes("sanctified-labaron") &&
				!(characterNode.listEntry.isWarlord && characterNode.entrySlug === "scion-of-conquest" && c.listEntry.slug === "drum-beast")
			) {
				alerts.push({ message: `${c.listEntry.name} is not part of this Character's Mainstay options.` });
			}
		});
		children.filter(c => c.type === "restricted").forEach(c => {
			if (!allRestricted.includes(c.listEntry.slug) && !characterNode.selections.includes("sanctified-labaron")) {
				alerts.push({ message: `${c.listEntry.name} is not part of this Character's Restricted options.` });
			}
		});

		const countDrumBeast = children.filter(c => c.entrySlug === "drum-beast").length;
		if (countDrumBeast > 1) {
			alerts.push({ message: "Only one Drum Beast may be purchased per Warband." });
		}

		let bestialDevolution = false;
		if (["vargyr-lord", "blooded-nords"].includes(characterNode.entrySlug)) {
			const valid = eligibleRegimentNodes.filter(n => n.listEntry.tagGroups.find(g => g.slug === "battlefield-role")?.tags?.find(t => t.slug === "half-bloods"));
			bestialDevolution = valid.length > 0;
		}

		if (characterNode.selections.includes("hierotekton") && !childrenSlugs.find(s => s === "bone-golems")) {
			alerts.push({ message: "Warband must inluce a Regiment of Bone Golems for the Character to join." });
		} else if (
			characterType !== "Monster" &&
			!characterNode.selections.includes("hellbringer-sorcerer") &&
			!characterNode.selections.includes("lineage-commander") &&
			!characterNode.selections.includes("draic-rider") &&
			!characterNode.selections.includes("bergont-raegh") &&
			!characterNode.selections.includes("apex-master") &&
			!characterNode.selections.includes("lord-of-all-they-see") &&
			!characterNode.selections.includes("tontorr-rider") &&
			!characterNode.selections.includes("drum-beast-rider") &&
			!characterNode.selections.includes("ferric-throne") &&
			!characterNode.selections.includes("bound-to-the-elements") &&
			!(characterNode.selections.includes("cloud-seeding") && childrenSlugs.filter(s => ["sciathan-riders", "ciannir-riders", "gallowglass-warriors", "gallowglass-wardens"].includes(s)).length > 0 ) &&
			!(characterNode.entrySlug === "eidolon" && (eligibleRegimentTypes.includes("Brute") || eligibleRegimentTypes.includes("Infantry"))) &&
			!(characterNode.entrySlug === "lost-ancestor" && (eligibleRegimentTypes.includes("Brute") || eligibleRegimentTypes.includes("Infantry"))) &&
			!bestialDevolution &&
			!eligibleRegimentTypes.includes(characterType)
		) {
			alerts.push({ message: "Warband must inluce a Regiment the Character is allowed to join." });
		}
	},
	"THUNDER_CHIEFTAIN_WARBAND": (node) => {
		const { alerts, children } = node;
		const ridersCount = children.filter(c => c.entrySlug === "thunder-riders").length;

		if (ridersCount > 2) {
			alerts.push({ message: "This Warband may not contain more than 2 Regiments of Thunder Riders." })
		}
	},
	"SCION_OF_WAR_WARBAND": (node) => {
		const { alerts, children } = node;
		const chosenCount = children.filter(c => c.entrySlug === "chosen-of-war").length;

		if (chosenCount > 2) {
			alerts.push({ message: "This Warband may not contain more than 2 Regiments of Chosen of War." })
		}
	},
	"SCION_OF_DEATH_WARBAND": (node) => {
		const { alerts, children } = node;
		const chosenCount = children.filter(c => c.entrySlug === "chosen-of-death").length;

		if (chosenCount > 2) {
			alerts.push({ message: "This Warband may not contain more than 2 Regiments of Chosen of Death." })
		}
	},
	"LIMIT_OPTIONS": (node) => {
		const { listEntry, alerts, linkedNodes, options } = node;
		if (options?.groups?.length) {
				for (const g of options.groups) {
					if (g.active === false) continue;

					let count = 0;
					if (g.groups) {
						count = g.groups.reduce((prev, s) => prev + s.orphans.filter(o => o.selected).length, 0);
					} else {
						count = g.orphans.filter(o => o.selected).length;
					}

					if (count > g.maxOptions) {
						alerts.push({ message: `Selected ${g.name} are over the maximum (${g.maxOptions}).` });
					}
					if (count < g.minOptions) {
						alerts.push({ message: `Selected ${g.name} are below the minimum (${g.minOptions}).` });
					}
				}
		} else if (listEntry) {
			const { options, entrySelectors } = listEntry;
			if (options?.groups?.length) {
				for (const g of options.groups) {
					if (g.active === false) continue;

					let count = 0;
					if (g.groups) {
						count = g.groups.reduce((prev, s) => prev + s.orphans.filter(o => o.selected).length, 0);
					} else {
						count = g.orphans.filter(o => o.selected).length;
					}

					if (count > g.maxOptions) {
						alerts.push({ message: `Selected ${g.name} are over the maximum (${g.maxOptions}).` });
					}
					if (count < g.minOptions) {
						alerts.push({ message: `Selected ${g.name} are below the minimum (${g.minOptions}).` });
					}
				}
			}

			if (entrySelectors) {
				for (const s of entrySelectors) {
					const { active, minOptions, name, slug } = s;
					if (active === false) continue;
					if ((linkedNodes[slug]?.length || 0) < minOptions) {
						alerts.push({ message: `${name} requires a valid target.` });
					}
				}
			}
		}
	},
	"2UPGRADES": (node, params, faction) => {
		const { listEntry: character, alerts, selections } = node;
		const { options, tagGroups, profiles, type } = character;
		const upgradeCategories = ["apparatuses", "eccentricities"];
		const groups = options.groups.filter(g => upgradeCategories.includes(g.slug));
		let count = 0;
		groups.forEach(g => {
			count += g.orphans.filter(o => o.selected).length;
		});

		if (count > 2) {
			alerts.push({ message: "May purchase up to 2 Eccentricities or Apparatuses in any combination." });
		}
	},
	"1UPGRADE": (node, params, faction) => {
		const { listEntry: character, alerts, selections } = node;
		const { options, tagGroups, profiles, type } = character;
		const upgradeCategories = ["apparatuses", "eccentricities", "mutations"];
		const groups = options.groups.filter(g => upgradeCategories.includes(g.slug));
		let count = 0;
		groups.forEach(g => {
			count += g.orphans.filter(o => o.selected).length;
		});

		if (count > 1) {
			alerts.push({ message: "May purchase up to 1 Upgrade in any category." });
		}
	},
	"CHARACTER": (node, params, faction) => {
		const { listEntry: character, alerts, selections } = node;
		// if (character.slug === "fallen-divinity") return;

		const { options, tagGroups, profiles, type } = character;
		const itemCategories = ["heirlooms", "artefacts", "trove-finds", "relics", "bestowed-relics", "patron-s-gifts"];
		if (faction.slug === "sorcerer-kings") itemCategories.push("masteries");

		const groups = options.groups.filter(g => itemCategories.includes(g.slug));

		let banners = 0;
		let weapons = 0;
		let talismans = 0;
		let armors = 0;
		let arcane = 0;

		groups.forEach(g => {
			const bannersGroup = g.groups?.find(g => g.slug === "banners")
			if (bannersGroup) {
				banners += bannersGroup.orphans.filter(o => o.selected).length
			}

			const weaponsGroup = g.groups?.find(g => g.slug === "weapons")
			if (weaponsGroup) {
				weapons += weaponsGroup.orphans.filter(o => o.selected).length
			}

			const armorsGroup = g.groups?.find(g => g.slug === "armors")
			if (armorsGroup) {
				armors += armorsGroup.orphans.filter(o => o.selected).length
			}

			const talismansGroup = g.groups?.find(g => g.slug === "talismans")
			if (talismansGroup) {
				talismans += talismansGroup.orphans.filter(o => o.selected).length
			}

			const arcaneGroup = g.groups?.find(g => g.slug === "arcane")
			if (arcaneGroup) {
				arcane += arcaneGroup.orphans.filter(o => o.selected).length
			}

			let multiples = false;
			g.groups?.forEach(gg => {
				const selected = gg.orphans.filter(o => o.selected).length;
				multiples ||= selected > 1;
			})

			if (multiples) {
				alerts.push({ message: `Selected ${g.name} must belong in different categories` });
			}

			let isPriest = false;
			let isWizard = false;
			let isRider = false;
			const tagGroup = tagGroups?.find(g => g.slug === "special-rules") || profiles?.[0]?.tagGroups?.find(g => g.slug === "special-rules");
			if (tagGroup) {
				isPriest = !!tagGroup.tags.find(t => t.slug === "priest");
				isWizard = !!tagGroup.tags.find(t => t.slug === "wizard");
				isRider = !!tagGroup.tags.find(t => t.slug === "rider");
			}

			if (arcane > 0 && !isPriest && !isWizard) {
				alerts.push({ message: `Arcane ${g.name} are not allowed to Characters without the Priest or Wizard Special Rules.` });
			}

			if (armors > 0 && isWizard && faction.slug !== "the-hundred-kingdoms") {
				alerts.push({ message: `Armor ${g.name} are not allowed to Characters with the Wizard Special Rule.` });
			}

			if (armors > 0 && isPriest && faction.slug === "the-old-dominion") {
				alerts.push({ message: `Armor ${g.name} are not allowed to Characters with the Priest Special Rule.` });
			}

			if (banners > 0 && type !== "Infantry") {
				alerts.push({ message: "Only Infantry Character Stands may purchase a Banner Character Upgrade." });
			}
			if (banners > 0 && isRider) {
				alerts.push({ message: "Characters with a Banner Character Upgrade cannot be attached to a Monster Regiment." });
			}
		})


		// MASTERIES
		if (faction.slug === "sorcerer-kings") {
			if (selections.includes("prince-of-the-setting-moon") && !character.isWarlord) {
				alerts.push({ message: "Prince of the Setting Moon requires the Character to be a Warlord." });
			}
			if (selections.includes("recorder-of-all-deeds") && !character.isWarlord) {
				alerts.push({ message: "Recorder of all Deeds requires the Character to be a Warlord." });
			}
			if (selections.includes("vizier-of-the-morning-star") && !character.isWarlord) {
				alerts.push({ message: "Vizier of the Morning Star requires the Character to be a Warlord." });
			}
			if (selections.includes("lord-of-all-they-see")) {
				const rolesGroup = character.tagGroups.find(g => g.slug === "battlefield-role");
				if (rolesGroup && !rolesGroup.tags.find(t => t.slug === "court-of-earth")) {
					alerts.push({ message: "Favored of Hormus requires a Maharajah or Sorcerer from the Court of Earth." });
				}
			}
		} else if (faction.slug === "dweghom") {
		} else if (faction.slug === "the-hundred-kingdoms") {
			if (selections.includes("order-warhorses")) {
				if (!character.isWarlord && !selections.includes("dynastic-ally")) {
					alerts.push({ message: "Order Warhorses requires the Character to be a Warlord." });
				}
				const rolesGroup = character.tagGroups.find(g => g.slug === "battlefield-role");
				if (rolesGroup) {
					let roles = rolesGroup.tags.map(t => t.slug);
					roles = roles.filter(r => r !== "character");
					if (roles.find(r => r !== "the-orders")) {
						alerts.push({ message: "Order Warhorses requires the Character to have the [THE ORDERS] Battlefield Role only." });
					}
				}
			}
		} else if (faction.slug === "the-wadrhun") {
			let cults = [];
			const cultGroup = character.tagGroups.find(g => g.slug === "cult");
			if (cultGroup) {
				cults = cultGroup.tags.map(t => t.slug);
			}

			if (selections.includes("authority") && (!character.isWarlord || !cults.includes("war"))) {
				alerts.push({ message: "Authority requires the Character to be a Warlord following the Cult of War." });
			}
			if (selections.includes("drive") && (!character.isWarlord || !cults.includes("famine"))) {
				alerts.push({ message: "Drive requires the Character to be a Warlord following the Cult of Famine." });
			}
			if (selections.includes("blood") && (!character.isWarlord || !cults.includes("death"))) {
				alerts.push({ message: "Blood requires the Character to be a Warlord following the Cult of Death." });
			}
			if (selections.includes("cure") && !cults.includes("death")) {
				alerts.push({ message: "Cure requires the Character to follow the Cult of Death." });
			}
			if (selections.includes("roar-of-the-tribe") && !cults.includes("conquest")) {
				alerts.push({ message: "Roar of the Tribe requires the Character to follow the Cult of Conquest." });
			}
			if (selections.includes("scars-of-endekar") && !cults.includes("famine")) {
				alerts.push({ message: "Scars of Endekar requires the Character to follow the Cult of Famine." });
			}
			if (selections.includes("death-s-gaze") && !cults.includes("death")) {
				alerts.push({ message: "Death's Gaze requires the Character to follow the Cult of Death." });
			}
			if (selections.includes("the-horn-of-ronan") && !cults.includes("war")) {
				alerts.push({ message: "The Horn of Ronan requires the Character to follow the Cult of War." });
			}
		}

		// TODO:  Create a generic CLASHES_WITH rule
		// MUTATIONS
		if (selections.includes("marksman-optimization-strain") && selections.includes("infiltration-optimization-strain")) {
			alerts.push({ message: "Marksman Optimization Strain and Infiltration Optimization Strain cannot be combined." });
		}
		// if (!selections.includes("warlord") && selections.includes("master-of-flesh")) {
		// 	alerts.push({ message: "Master of Flesh can only be selected by a Warlord." });
		// }
		if (!selections.includes("warlord") && selections.includes("chain-reaction")) {
			alerts.push({ message: "Chain Reaction can only be selected by a Warlord." });
		}
		if (!selections.includes("warlord") && selections.includes("cautious-strike")) {
			alerts.push({ message: "Cautious Strike can only be selected by a Warlord." });
		}
		if (!selections.includes("warlord") && selections.includes("call-the-hunt")) {
			alerts.push({ message: "Call the Hunt can only be selected by a Warlord." });
		}

		// ARTEFACTS
		const hasOmgorah = selections.includes("brood-of-omgorah");
		const hasApex = selections.includes("apex-master");
		const hasTontorr = selections.includes("tontorr-rider");
		const hasDrumBeast = selections.includes("drum-beast-rider");

		if (hasApex && hasOmgorah) {
			alerts.push({ message: "Apex Master and Brood of Omgorah cannot be combined." });
		}
		if (hasTontorr && hasOmgorah) {
			alerts.push({ message: "Tontorr Rider and Brood of Omgorah cannot be combined." });
		}
		if (hasDrumBeast && hasOmgorah) {
			alerts.push({ message: "Drum Beast Rider and Brood of Omgorah cannot be combined." });
		}

		if (!selections.includes("court-of-winter") && selections.includes("winter-s-bite")) {
			alerts.push({ message: "Winter's Bite requires Court of Winter." });
		}

		// WARLORD
		if (selections.includes("warlord") && selections.includes("dynastic-ally")) {
			alerts.push({ message: "Only one type of Warlord can be selected." });
		}
	},
	"ADDITIONAL_SPELLS": (node) => {
		const { alerts, selections } = node;

		if (
			(selections.includes("school-of-fire") && (selections.includes("kindle-courage") || selections.includes("fire-dart"))) ||
			(selections.includes("school-of-water") && (selections.includes("ninuah-s-tears") || selections.includes("call-fog"))) ||
			(selections.includes("school-of-earth") && (selections.includes("earth-to-mud") || selections.includes("stone-spikes"))) ||
			(selections.includes("school-of-air") && (selections.includes("seeking-winds") || selections.includes("guide")))
		) {
			alerts.push({ message: "Additional spells must come from a different School." });
		}
	},
	"OMNIPOTENCE": (node, params, faction) => {
		let sorcererCourt = null;
		let missing = false;

		const characters = node.children.map(w => w.children.find(c => c.type === "character"));
		const sorcerer = characters.find(c => c.entrySlug === "sorcerer" && c.listEntry.isWarlord);

		if (sorcerer) {
			const rolesGroup = sorcerer.listEntry.tagGroups.find(g => g.slug === "battlefield-role");
			const role = rolesGroup.tags.filter(t => t.slug.startsWith("court-of"))?.[0];
			sorcererCourt = role;

			if (sorcererCourt) {
				const others = characters.filter(c => c.id !== sorcerer.id);
				others.forEach(c => {
					const cRolesGroup = c.listEntry.tagGroups.find(g => g.slug === "battlefield-role");
					const cRoles = cRolesGroup.tags.filter(t => t.slug.startsWith("court-of"));
					if (!cRoles.map(r => r.slug).includes(sorcererCourt.slug)) missing = true;
				});
			}
		}

		if (missing) {
			node.alerts.push({ message: `All Characters must follow the ${sorcererCourt.name}` });
		}
	},
	"REQUIRES_WARLORD": (node, params, faction) => {
		const { entrySlugs } = params;
		const { alerts, children } = node;
		const warlordSlugs = [];

		children.forEach(w => {
			const character = w.children.find(c => c.type === "character");
			if (character && character.listEntry.isWarlord) {
				warlordSlugs.push(character.listEntry.slug);
			}
		});
		if (!warlordSlugs.some(s => entrySlugs.includes(s))) {
			const entryNames = entrySlugs.map(s => faction.entries[s].name);
			alerts.push({ message: "One of the following Characters must be selected to be the Warlord: " + entryNames.join(", ") });
		}
	},
	"TEMPERED_SPELLS": (node) => {
		// const { alerts, selections } = node;
		// let fireCount = 0;
		// let earthCount = 0;
		// let magmaCount = 0;
		// let hasOccult = false;
		// let hasHellbringer = false;

		// selections.forEach(s => {
		// 	if (["flame-wall", "fireball", "coruscation"].includes(s)) fireCount += 1;
		// 	else if (["roots-of-stone", "broken-ground", "rock-shaping"].includes(s)) earthCount += 1;
		// 	else if (["eruption", "magmatic-seep", "pyroclast"].includes(s)) magmaCount += 1;
		// 	else if (s === "learned-in-the-occult") hasOccult = true;
		// 	else if (s === "hellbringer-sorcerer") hasHellbringer = true;
		// })

		// if (hasHellbringer && earthCount > 0) {
		// 	alerts.push({ message: "A Hellbringer Sorcerer must select Spells from the Schools of Fire or Magma." });
		// }

		// if (hasOccult) {
		// 	if (
		// 		(fireCount > 1 && earthCount + magmaCount > 1) ||
		// 		(earthCount > 1 && fireCount + magmaCount > 1) ||
		// 		(magmaCount > 1 && earthCount + fireCount > 1) ||
		// 		(magmaCount === 1 && earthCount === 1 && fireCount === 1)
		// 	) {
		// 		alerts.push({ message: "Learned in the Occult allows for one Spell from a different School." });
		// 	}
		// } else {
		// 	if (
		// 		(fireCount > 0 && earthCount + magmaCount > 0) ||
		// 		(earthCount > 0 && fireCount + magmaCount > 0) ||
		// 		(magmaCount > 0 && earthCount + fireCount > 0)
		// 	) {
		// 		alerts.push({ message: "Selected spells must belong to the same School." });
		// 	}
		// }
	},
	"ONLY_ONE_OF": (node, params) => {
		const { listEntry, alerts } = node;
		const { groups = [] } = params;

		const targets = listEntry.options.groups.filter(g => groups.includes(g.slug));

		function countSelected(group) {
			const countOrphans = group.orphans?.filter(o => o.selected)?.length || 0;
			const countGroups = group.groups?.reduce((prev, cur) => prev + countSelected(cur), 0) || 0;
			return countOrphans + countGroups;
		}

		const count = targets.reduce((prev, cur) => prev + countSelected(cur), 0);

		if (count > 1) {
			alerts.push({ message: `You can only select one of: ${targets.map(t => t.name).join(", ")}` });
		}
	},
	"BOUND_TO_THE_ELEMENTS": (node) => {
		const { listEntry, alerts } = node

		const rolesGroup = listEntry.tagGroups?.find(g => g.slug === "battlefield-role");
		if (rolesGroup) {
			const roles = rolesGroup.tags.filter(t => t.slug.startsWith("court-of")).map(t => t.slug);
			let found = false;

			const regiments = node.parent.children.filter(c => c.type !== "character");
			regiments.forEach(c => {
				const childRolesGroup = c.listEntry.tagGroups?.find(g => g.slug === "battlefield-role");
				if (childRolesGroup) {
					const childRoles = childRolesGroup.tags.filter(t => t.slug.startsWith("court-of")).map(t => t.slug);
					if (childRoles.filter(r => roles.includes(r)).length > 0) found = true;
				}
			})

			// if (!found) {
			// 	alerts.push({ message: "This Character must be attached to a Regiment of the same Court." });
			// }
		}
	},
	"LINEAGE_COMMANDER": (node) => {
		const clones = node.children.filter(c => c.entrySlug === "bound-clones").length;
		if (clones < 1) {
			node.alerts.push({ message: "This Warband must contain at least one Regiment of Bound Clones" });
		}
	},
	"MODULAR_REGIMENT": (node) => {
		let leader = null;
		const stands = {
			"oni-ayakashi": 0,
			"kami-ayakashi": 0,
			"tengu-bushi": 0,
			"tengu-ayakashi": 0,
			"kappa-bushi": 0,
			"origami-warriors": 0,
		};

		for (const s of node.selections) {
			if (s === "oni-ayakashi-leader") {
				leader = "oni-ayakashi";
			} else if (s === "kami-ayakashi-leader") {
				leader = "kami-ayakashi";
			} else if (s === "tengu-bushi-leader") {
				leader = "tengu-bushi";
			} else if (s === "tengu-ayakashi-leader") {
				leader = "tengu-ayakashi";
			} else if (s === "kappa-bushi-leader") {
				leader = "kappa-bushi";
			} else if (s === "origami-warriors-leader") {
				leader = "origami-warriors";
			} else {
				++stands[s];
			}
		}

		if (leader) {
			const standsSize = node.listEntry.size;
			const leaderSize = stands[leader] + 1;
			if (leaderSize < standsSize / 2) {
				node.alerts.push({ message: "At least half of the Regiment's Stands must share the Leader's Army List Entry." });
			}
			const others = Object.keys(stands).filter(k => k !== leader);
			others.forEach(k => {
				if (stands[k] >= leaderSize) {
					node.alerts.push({ message: "The number of the same Regiment's Stands that do not share the Command Stand's Army List Entry must be lower than the number of Regiment's Stands that share the Command Stand Army List Entry." });
				}
			})
		}
	}
};


export default TLAOK_RULES;